<template>
  <div class="hbox-container"  :class="params.className" :style="{padding:params.padding}" ref="ct">
    <div class="hbox-column" v-for="(col,index) in params.columns" :key="index"
         :style='{"padding-left":col.paddingLeft,"padding-right":col.paddingRight,width:col.width}'
         :class="{'fit-height':!params.dynamicHeight}"
         ref="columns"
    >
      <div class="hbox-item" v-for="item in col.items" :style="{height:item.height || '100%'}">
        <component :is="item.xtype" :params="item"></component>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'hbox',
    props:{
      params:Object
    },
    data(){
      return {}
    },
    mounted() {
      if (this.params.style) {
       this.appendStyle(this.$refs.ct, this.params.style);
      }
      this.params.columns.forEach((r,idx)=>{
        if(r.style){
          let div=this.$refs.columns[idx];
          this.appendStyle(div,r.style);
        }
      });
    },
    methods:{
      appendStyle(el,style){
        let oldStyle=$(el).attr("style") || "";
        $(el).attr("style", oldStyle + "; " + style);
      }
    }
  }
</script>
<style scoped>
  .hbox-container{
    height:calc(100% - 4px);
  }
  .fit-height{
    height:100%;
  }
  /*.hbox-item{*/
    /*display:inline-block;*/
  /*}*/
  .hbox-column{
    display:inline-block;
    float:left;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/extend/layout/hbox.vue